<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
    </d-card-header>

    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <span class="d-flex mb-2" v-if="model.user">
            <i class="material-icons mr-1">face</i>
            <d-col class="page-title p-0">
              <strong class="mr-1" >Proprietário:</strong>
              <span class="ml-auto">{{ model.user.name }}</span>
            </d-col>
          </span>
          <span class="d-flex mb-2" v-if="isNotCustomer">
            <i class="material-icons mr-1">table_chart</i>
            <d-col class="page-title p-0">
              <strong class="mr-1" >Obra:</strong>
              <d-link
                v-if="model.project"
                class="ml-auto"
                :to="{params:{projectId: model.project.id},name:'admin-project-edit'}"
                target="_blank"
                >{{ model.project.label }}</d-link>
            </d-col>
          </span>
          <span class="d-flex mb-2" >
            <i class="material-icons mr-1">list_alt</i>
            <d-col class="page-title p-0">
              <strong class="mr-1" >Tipo:</strong>
              <span class="ml-auto">{{ (model.type) ? model.type.name : '-' }}</span>
            </d-col>
          </span>
          <span class="d-flex mb-2" >
            <i class="material-icons mr-1">flag</i>
            <d-col class="page-title p-0">
              <strong class="mr-1" >Status:</strong>
              <template v-if="!editStatus">
                <span class="ml-auto">{{ (model.id) ? model.status : 'Novo' }}</span>
              </template>
              <template v-else>
                <d-select
                  size="sm"
                  v-model="model.status_slug"
                  class="w-auto"
                  @blur.native="toggleEdit('editStatus')"
                  @change="saveStatus"
                  :options="statusOptions"
                ></d-select>
              </template>
            </d-col>
            <a class="ml-auto" href="#" @click="toggleEdit('editStatus')" v-if="model.id">Editar</a>
          </span>
          <span class="d-flex mb-2">
            <i class="material-icons mr-1">calendar_today</i>
            <strong class="mr-1">Data:</strong>
            <span>{{date}}</span>
          </span>
          <span class="d-flex mb-2" v-if="isNotCustomer">
            <i class="material-icons mr-1">supervised_user_circle</i>
            <strong class="mr-1">Departamento:</strong>
            <template v-if="!editRole">
              <span>{{ (model.role && model.role.name) ? model.role.name : 'Nenhum' }}</span>
            </template>
            <template v-else>
              <d-select
                size="sm"
                v-model="model.role_id"
                class="w-75"
                @blur.native="toggleEdit('editRole')"
                @change="saveRole"
                :options="rolesOptions"
                value-field="id"
                text-field="name"
              ></d-select>
            </template>
            <a class="ml-auto" href="#" @click="toggleEdit('editRole')">Editar</a>
          </span>
        </d-list-group-item>

      </d-list-group>
    </d-card-body>
    <d-card-footer class="border-top" v-if="isOwner && model.status_slug !== 'closed'">
      <d-button class="btn-success float-right" href="#" @click="closeTicket">Encerrar</d-button>
    </d-card-footer>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { MODEL, STATUS_OPTIONS, _RESET_MODEL_, _OPEN_CONFIRMATION_ } from './TicketModel';

export default {
  name: 'sidebar-actions',
  props: {
    title: {
      type: String,
      default: 'Ações',
    },
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  computed: {
    date() {
      if (this.model.created_at instanceof Date) {
        return this.model.created_at.toLocaleDateString();
      }
      return new Date(this.model.created_at).toLocaleDateString();
    },
    isOwner() {
      const { user } = this.$store.state.user;
      if (this.model.user.id === user.id) {
        return true;
      }
      return false;
    },
    rolesOptions() {
      const { roles } = this.$store.state.settings;
      if (roles.length > 0) {
        return [{ id: null, status_id: null, name: 'Selecione um departamento' }].concat(roles);
      }
      return [];
    },
    isNotCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) { // User type id : Customer
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      editRole: false,
      editStatus: false,
      statusOptions: STATUS_OPTIONS,
      oldValue: null,
    };
  },
  methods: {
    ...mapActions([
      'getRoles',
      'setToggle',
      'activeAlert',
      'updateTicket',
    ]),
    callback() {
      const { callback } = this.confirmation[this.type];
      this[callback]();
    },
    getRoleOptions() {
      if (!this.$store.state.settings.roles) {
        this.getRoles();
      }
      return true;
    },
    toggleEdit(field) {
      this[field] = !this[field];
    },
    closeTicket() {
      const params = {
        object: {
          id: this.model.id,
          status: 'closed',
          field: 'status',
        },
        type: 'close',
        message: 'Chamado finalizado com sucesso',
      };
      Events.$emit(_OPEN_CONFIRMATION_, params);
    },
    saveStatus(status) {
      this.oldValue = { status_slug: this.model.status_slug };
      const params = {
        object: {
          id: this.model.id,
          status,
          field: 'status',
        },
        type: 'status',
        message: 'Status do chamado alterado com sucesso',
      };
      Events.$emit(_OPEN_CONFIRMATION_, params);
    },
    saveRole(role) {
      this.oldValue = { role_id: this.model.role_id };
      const params = {
        object: {
          id: this.model.id,
          role_id: role,
          field: 'role_id',
        },
        type: 'role',
        message: 'Departamento do chamado alterado com sucesso',
      };
      Events.$emit(_OPEN_CONFIRMATION_, params);
    },
  },
  mounted() {
    this.getRoleOptions();
    Events.$on(_RESET_MODEL_, () => {
      this.model = Object.assign(this.model, this.oldValue);
    });
  },
};
</script>
<style lang="scss" scoped>
i.material-icons {
  top: 5px;
}
</style>
